<template>
    <div ref="gallery">
        <header class="header d-flex flex-column flex-md-row align-items-md-end justify-content-between pb-3">
            <h3 class="title">
                <div
                    v-if="gallery.title_visible"
                >
                    <a
                        v-if="isTitleClickable"
                        :href="gallery.url"
                        target="_blank"
                    >
                        {{ gallery.name }}
                    </a>

                    <div v-else>
                        {{ gallery.name }}
                    </div>
                </div>
            </h3>
            <div class="param">
                {{ __('Összesen') }} <b>{{ gallery.media.length }}</b> {{ __('fotó') }} | {{ gallery.date }}
            </div>
        </header>

        <div
            class="grid"
            :class="{ 'limited': ! revealed }"
            data-colcade="columns: .grid-col, items: .grid-item"
        >
            <div class="grid-col grid-col--1" />
            <div class="grid-col grid-col--2" />
            <div class="grid-col grid-col--3" />
            <div class="grid-col grid-col--4" />

            <div
                v-for="(slide, key) in gallery.media"
                :key="key"
                class="grid-item slide-item"
                :class="'gallery-show-' + gallery.preview_image_count"
                :data-src="slide.url"
                :data-sub-html="getSubHtml(slide)"
            >
                <img
                    :src="slide.thumb"
                    :alt="slide.title"
                    tabindex="0"
                >
                <a
                    v-if="isDownloadable"
                    class="floating-download-button"
                    :href="slide.downloadUrl"
                >
                    <img
                        src="/images/download-image.svg"
                        class="dl-ico"
                        :alt="__('Download image')"
                    >
                </a>
            </div>
        </div>

        <div class="d-flex justify-content-between gallery-category-control">
            <div class="controls">
                <a
                    v-if="isDownloadable"
                    :href="gallery.downloadUrl"
                    class="btn-download text-transform-none"
                >
                    <svg class="icon icon-download ml-0 mr-1"><use xlink:href="#icon-download" /></svg>
                    {{ __('Download all images') }}
                </a>
            </div>
            <div class="controls text-right">
                <button
                    v-if="! revealed"
                    class="btn-download text-transform-none"
                    @click="reveal"
                >
                    {{ __('More images') }}
                    <svg class="icon icon-chevrondown"><use xlink:href="#icon-chevrondown" /></svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import lightGallery from 'lightgallery'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

export default {
    name: 'Gallery',
    props: {
        gallery: {
            type: Object,
            require: true,
            default: null
        },

        isDownloadable: {
            type: Boolean,
            default: false,
        },

        isTitleClickable: {
            type: Boolean,
            default: false
        },

        withThumbnails: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            revealed: false,
            lightGallery: null
        }
    },

    mounted() {
        this.initLightGallery()
        this.initColcade()
    },

    methods: {
        getSubHtml(slide) {
            return `<div className=captionWrap>${this.getCaptionContent(slide)}</div>`
        },

        getCaptionContent(slide) {
            const subtitle = this.getSubtitle(slide)
            const caption = this.getCaption(slide)

            if (! subtitle && ! caption) {
                return this.getName(slide)
            }

            return `${subtitle}${caption}`
        },

        getSubtitle(slide) {
            if (slide.title) {
                return `<h4 className=title>${slide.title}</h4>`
            }

            return ''
        },

        getCaption(slide) {
            if (slide.caption) {
                `<div className=text>${slide.caption}</div>`
            }

            return ''
        },

        getName() {
            return `<h4 class=title>${this.gallery.name}</h4>`
        },

        reveal() {
            this.revealed = true
        },

        initLightGallery() {
            lightGallery(this.$refs.gallery, {
                speed: 500,
                thumbnail: this.withThumbnails,
                plugins: this.withThumbnails ? [lgThumbnail, lgZoom] : [],
                selector: '.slide-item',
                download: this.isDownloadable,
                // Append caption inside the slide item
                // to apply some animation for the captions (Optional)
                appendSubHtmlTo: '.lg-item',
                // Delay slide transition to complete captions animations
                // before navigating to different slides (Optional)
                // You can find caption animation demo on the captions demo page
                slideDelay: 400,
                licenseKey: '0A003BB3-3039466A-918940DD-C83982AE',
                // eslint-disable-next-line no-undef
                nextHtml : '<svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg>',
                // eslint-disable-next-line no-undef
                prevHtml : '<svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg>'
            })
        },

        initColcade() {
            this.$refs.gallery.querySelectorAll('[data-colcade]')
                .forEach(element => this.colcadeHtmlInit(element))
        },

        colcadeHtmlInit(element) {
            // convert attribute "foo: bar, qux: baz" into object
            const attr = element.getAttribute('data-colcade')
            const attrParts = attr.split(',')

            const options = {}

            attrParts.forEach(function(part) {
                const pair = part.split(':')
                const key = pair[0].trim()

                options[key] = pair[1].trim()
            })

            new window.Colcade(element, options)
        }
    }
}
</script>

<style scoped>

</style>
